<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    #app {
        font-family: "Microsoft YaHei",微软雅黑,"Microsoft JhengHei",华文细黑,STHeiti,MingLiu;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        font-size: 16px;
    }

    .ivu-form .ivu-form-item-label {
        font-size: 14px;
    }

    .ivu-btn {
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue